import {
  isTraceInProgress,
  type TracePreviewDto,
} from '@terra/shared-contracts-trace';
import type {
  BlockedReasonType,
  ConfirmedVulnerabilityFindingStateType,
  SignalStageType,
  SignalStatusType,
} from '@terra/shared-schemas-orchestrator';

export type TraceResultDisplay =
  | {
      kind: 'signal';
      status: SignalStatusType;
      stage?: SignalStageType | null;
      blockedReason?: BlockedReasonType | null;
      confirmedVulnerabilityFindingState?: ConfirmedVulnerabilityFindingStateType | null;
      skipAttackReason?: string;
    }
  | {
      kind: 'guardrail';
      skipAttackReason?: string;
    }
  | {
      kind: 'empty';
    };

export function resolveTraceResultDisplay(
  trace: TracePreviewDto,
): TraceResultDisplay {
  if (isTraceInProgress(trace.status)) {
    return { kind: 'empty' };
  }

  const skipAttackReason = trace.skipAttackReason;
  const signalStatus = trace.signal?.status;

  if (signalStatus) {
    return {
      kind: 'signal',
      status: signalStatus,
      stage: trace.signal?.stage,
      blockedReason: trace.signal?.blockedReason,
      confirmedVulnerabilityFindingState:
        trace.signal?.confirmedVulnerabilityFindingState,
      skipAttackReason,
    };
  }

  if (trace.skipAttackReasonType === 'signal_blocked_by_guardrails') {
    return { kind: 'guardrail', skipAttackReason };
  }

  return { kind: 'empty' };
}
